import type { ThemeKey } from 'Src/types/theme';
import type { ReactNode } from 'react';
import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { ICONS } from 'Components/utils/icon/icons';
import { Icon } from 'Components/frameworks/icon/Icon';
import { themes } from './DropZone.themes';
type DropZoneProps = {
  children?: ReactNode;
  className?: string;
  label?: string;
  number?: number;
  onClear?: (() => void) | null | undefined;
  theme?: ThemeKey<typeof themes>;
};
export const DropZone = ({
  children,
  className,
  label,
  number,
  onClear,
  theme = 'default',
}: DropZoneProps) => {
  const { thChildren, thClear, thClearIconSize, thLabel, thNumber, thRoot, thRootFilled } =
    themes[theme];
  return children ? (
    <div className={classnames(thRootFilled, className)}>
      <div className={thChildren}>{children}</div>
      <button className={thClear} onClick={onClear} type="button">
        <Icon name={ICONS.CROSS} width={thClearIconSize} />
      </button>
    </div>
  ) : (
    <div className={classnames(thRoot, className)}>
      {!!number && <span className={thNumber}>{number}</span>}
      {!!label && <span className={thLabel}>{label}</span>}
    </div>
  );
};
